import {DocPayants} from './DocPayants';
export class InfosSup {

	public conditionsModePaiement: string;

	public docPayants: DocPayants;

	public dateLimiteObtention: string;

	constructor() { 
		 		this.conditionsModePaiement = '';
		this.docPayants = new DocPayants();
		this.dateLimiteObtention = '';
 
	}
}
